const $ = window.jQuery;
const $window = window.$window || $(window);

const UrlQuery = {

  init() {

    $(document).ready(function () {


      // --------------------
      // Append INT codes
      // Adds INT code to url on quote links if in url or stored
      // --------------------
      var int = $.getQuery('int');
      var storedINT;

      if (int && int.length > 0) {
        if (storage) {
          storage.setItem('int', int);
        }
      }

      if (storage) {
        storedINT = storage.getItem('int');
      } else {
        storedINT = int;
      }

      if (storedINT) {
        $('a[href*="myquote.ingenie.com"], a[href*="prequote.ingenie.com"], a[href*="learner.ingenie.com"]').each(function () {
          if ($(this).attr('href').indexOf('?') === -1) {
            $(this).attr('href', $(this).attr('href') + '?int=' + storedINT);
          } else {
            $(this).attr('href', $(this).attr('href') + '&int=' + storedINT);
          }
        });
      }

      // --------------------
      // Append GCLID codes
      // Adds GCLID code to url on quote links if in url or stored
      // --------------------
      var gclid = $.getQuery('gclid');
      var storedGCLID;

      if (gclid && gclid.length > 0) {
        if (storage) {
          storage.setItem('gclid', gclid);
        }
      }

      if (storage) {
        storedGCLID = storage.getItem('gclid');
      } else {
        storedGCLID = gclid;
      }

      if (storedGCLID) {
        $('a[href*="myquote.ingenie.com"], a[href*="prequote.ingenie.com"], a[href*="learner.ingenie.com"]').each(function () {
          if ($(this).attr('href').indexOf('?') === -1) {
            $(this).attr('href', $(this).attr('href') + '?gclid=' + storedGCLID);
          } else {
            $(this).attr('href', $(this).attr('href') + '&gclid=' + storedGCLID);
          }
        });
      }

      // --------------------
      // Get utm_campaign
      // Change color for marketing campaign /young-driver-car-insurance landing page
      // --------------------
      var utm = $.getQuery('utm_campaign');
      var urlCorrect = window.location.pathname.split("/")[1] === "young-driver-car-insurance";
      // console.log('utm_campaign', utm);
      // console.log('urlCorrect', urlCorrect);
      if (urlCorrect) {
        switch (utm) {
          case 'learner':
            $('body').addClass('learner');
            break;
          case 'justpassed':
            $('body').addClass('justpassed');
            break;
          case 'generic':
            $('body').addClass('generic');
            break;
          default:
            $('body').addClass('generic');
        }
      }

    });

    // console.log('Tracking codes js ready for get query!')
    // Get URL Parameters
    !function (e) { e.getQuery = function (e) { e = e.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); var n = '[\\?&]' + e + '=([^&#]*)', r = new RegExp(n), c = r.exec(window.location.href); return null !== c ? c[1] : !1 } }(jQuery);

    // Sessionstorage
    var storage = (function () {
      var uid = new Date;
      var storage;
      var result;
      try {
        (storage = window.sessionStorage).setItem(uid, uid);
        result = storage.getItem(uid) == uid;
        storage.removeItem(uid);
        return result && storage;
      } catch (exception) { }
    }());

  }

};

export default UrlQuery;